import { useEffect, useState } from "react";

import PanelTurnos, { estadoTurno } from "./PanelTurnos";
import { avisarError } from "../../shared/errores";
import {
  directorioMiembros, eliminar as eliminarFila, guardar as guardarFila, listar, listarReuniones, rpc, unir,
} from "../../services/datos";
import { accionCuenta } from "../configuracion/cuentasService";


import { esAreaInfantil } from "../configuracion/ConfigRotacionArea";

import { avisar, confirmar } from "../../shared/avisos";
import Selector from "../../shared/components/Selector";
import Esqueleto from "../../shared/components/Esqueleto";

function buscarMiembros(miembros, texto, excluirIds = new Set()) {

  const limpio = texto.trim().toLowerCase();

  if (!limpio) return [];

  return miembros

    .filter((m) => !excluirIds.has(m.id))

    .filter((m) => {

      const nombre = `${m.nombres} ${m.apellidos}`.toLowerCase();

      const correo = String(m.email || "").toLowerCase();

      return nombre.includes(limpio) || correo.includes(limpio);

    })

    .slice(0, 8);

}


function Servidores({ contexto }) {

  const [areas, setAreas] = useState([]);

  const [usuarios, setUsuarios] = useState([]);

  const [miembrosArea, setMiembrosArea] = useState([]);

  const [turnos, setTurnos] = useState([]);

  const [historial, setHistorial] = useState([]);

  const [reunionHistoricaSeleccionada, setReunionHistoricaSeleccionada] = useState(null);

  const [miembros, setMiembros] = useState([]);

  const [servicios, setServicios] = useState([]);

  const [areaSeleccionada, setAreaSeleccionada] = useState(null);


  const [filtroProgramacion, setFiltroProgramacion] = useState("");

  // Desde Calendario o Inicio se llega con una reunión elegida: se abre en Turnos.
  const [tab, setTab] = useState(contexto?.servicioId ? "turnos" : "servidores");

  const [cargando, setCargando] = useState(true);


  const [busquedaServidor, setBusquedaServidor] = useState("");

  const [miembroServidor, setMiembroServidor] = useState("");

  const [rolEnArea, setRolEnArea] = useState("");


  const cargarDatos = () => {

    Promise.all([

      listar("areas_servicio", { orden: "nombre" }),

      listar("miembro_area"),

      rpc("turnos_detalle"),

      directorioMiembros(),

      listarReuniones(),

    ])

      .then(([todasLasAreas, todosLosVinculos, todosLosTurnos, miembrosData, serviciosData]) => {

        // Mi Casa Kids se maneja en su propio menú (lo lleva otro equipo): aquí no aparece.
        const areasKids = new Set((todasLasAreas || []).filter((a) => a.es_infantil).map((a) => a.id));
        const fueraDeKids = (registro) => !areasKids.has(registro.area_id);
        const areasData = (todasLasAreas || []).filter((a) => !areasKids.has(a.id));

        setAreas(areasData);

        setMiembrosArea(unir((todosLosVinculos || []).filter(fueraDeKids), "miembro_id", miembrosData, "miembros"));

        setTurnos((todosLosTurnos || []).filter(fueraDeKids));

        setMiembros(miembrosData);

        setServicios(serviciosData);

        rpc("usuarios_detalle").then((lista) => setUsuarios(lista || [])).catch(() => setUsuarios([]));

        rpc("historial_turnos", { p_reuniones: 12 })

          .then((historialData) => setHistorial(
            (Array.isArray(historialData) ? historialData : []).filter((r) => fueraDeKids(r) && !esAreaInfantil(r.nombre_area))
          ))

          .catch(() => setHistorial([]));

        if (!areaSeleccionada && areasData.length > 0) {

          setAreaSeleccionada(areasData[0].id);

        }

        setCargando(false);

      })

      .catch((e) => { setCargando(false); avisarError(e); });

  };


  // Solo al abrir la pantalla (cargarDatos cambia en cada dibujo).
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { cargarDatos(); }, []);


  const asignarServidor = async () => {

    if (!areaSeleccionada || !miembroServidor) {

      avisar("Selecciona un área y un miembro");

      return;

    }

    try {

      await guardarFila("miembro_area", null, {
        miembro_id: parseInt(miembroServidor),
        area_id: parseInt(areaSeleccionada),
        rol_en_area: rolEnArea,
        activo: true,
      });

      setBusquedaServidor("");

      setMiembroServidor("");

      setRolEnArea("");

      cargarDatos();

    } catch (error) {

      console.error("Error asignando servidor:", error);

      avisar(error.message === "Failed to fetch"

        ? "No se pudo conectar con el servidor. Verifica que la API esté ejecutándose e inténtalo de nuevo."

        : error.message);

    }

  };


  const quitarServidor = async (id) => {

    if ((await confirmar("¿Quitar este servidor del área?", { aceptar: "Quitar" }))) {

      eliminarFila("miembro_area", id).then(() => cargarDatos()).catch(avisarError);

    }

  };


  // ─── Acceso de los servidores a la aplicación ───
  const usuarioDe = (miembroId) => usuarios.find((u) => u.miembro_id === miembroId);

  // Cada servidor recibe por correo un enlace para crear su contraseña (no hay contraseñas temporales).
  const darAcceso = async (miembroIds) => {
    try {
      const { invitados = [], omitidos = [] } = await accionCuenta("dar_acceso", { miembro_ids: miembroIds });
      const enviados = invitados.filter((i) => i.enviado).length;
      const partes = [];
      if (enviados) partes.push(`Se envió la invitación a ${enviados} servidor(es): con el enlace del correo crean su contraseña.`);
      if (invitados.length > enviados) partes.push(`${invitados.length - enviados} cuenta(s) quedaron creadas pero el correo no salió: usa “Reenviar acceso”.`);
      if (omitidos.length) partes.push(`${omitidos.length} no se incluyeron (${[...new Set(omitidos.map((o) => o.motivo))].join(", ")}).`);
      avisar(partes.join(" ") || "No hubo cambios.", enviados ? "exito" : "info");
      setUsuarios((await rpc("usuarios_detalle")) || []);
    } catch (error) {
      avisar(error.message || "No se pudo dar el acceso", "error");
    }
  };

  const reenviarAcceso = async (usuario, miembro) => {
    if (!(await confirmar(`¿Enviar de nuevo a ${miembro?.nombres || usuario.email} el enlace para entrar? Le llegará a ${usuario.email}.`, { aceptar: "Enviar enlace", peligro: false }))) return;
    try {
      await accionCuenta("reenviar", { usuario_id: usuario.id });
      avisar(`Se envió el enlace a ${usuario.email}.`, "exito");
    } catch (error) {
      avisar(error.message || "No se pudo enviar el enlace", "error");
    }
  };

  const servidoresDelArea = miembrosArea.filter((ma) => ma.area_id === parseInt(areaSeleccionada));

  const sinAcceso = servidoresDelArea.filter((ma) => !usuarioDe(ma.miembro_id)).map((ma) => ma.miembro_id);

  const areaSeleccionadaInfo = areas.find((area) => area.id === parseInt(areaSeleccionada));

  const idsEnArea = new Set(servidoresDelArea.map((ma) => ma.miembro_id));

  const resultadosServidor = buscarMiembros(miembros, busquedaServidor, idsEnArea);

  const miembroServidorSeleccionado = miembros.find((m) => m.id === parseInt(miembroServidor));


  const programacionPorServicio = Object.values(
    turnos
      .filter((turno) => !filtroProgramacion || String(turno.servicio_id) === filtroProgramacion)
      .reduce((serviciosAgrupados, turno) => {
        const servicio = turno.servicios || {};
        const servicioId = turno.servicio_id || "sin-servicio";

        if (!serviciosAgrupados[servicioId]) {
          serviciosAgrupados[servicioId] = {
            id: servicioId,
            fecha: servicio.fecha || "",
            hora: servicio.hora || "",
            titulo: servicio.titulo || servicio.tipos_servicio?.nombre || "Servicio sin nombre",
            tipo: servicio.tipos_servicio?.nombre || "Servicio",
            areas: {},
          };
        }

        const areaId = turno.area_id || "sin-area";
        const nombreArea = turno.areas_servicio?.nombre || "Área sin asignar";
        if (!serviciosAgrupados[servicioId].areas[areaId]) {
          serviciosAgrupados[servicioId].areas[areaId] = { id: areaId, nombre: nombreArea, turnos: [] };
        }

        serviciosAgrupados[servicioId].areas[areaId].turnos.push(turno);
        return serviciosAgrupados;
      }, {})
  )
    .map((servicio) => ({
      ...servicio,
      areas: Object.values(servicio.areas)
        .map((area) => ({
          ...area,
          turnos: area.turnos.sort((a, b) => {
            const nombreA = `${a.miembros?.nombres || ""} ${a.miembros?.apellidos || ""}`;
            const nombreB = `${b.miembros?.nombres || ""} ${b.miembros?.apellidos || ""}`;
            return nombreA.localeCompare(nombreB);
          }),
        }))
        .sort((a, b) => a.nombre.localeCompare(b.nombre)),
    }))
    .sort((a, b) => (b.fecha || "").localeCompare(a.fecha || "") || (b.hora || "").localeCompare(a.hora || ""));

  const resumenProgramacion = programacionPorServicio.flatMap((servicio) => servicio.areas.flatMap((area) => area.turnos)).reduce(
    (resumen, turno) => ({
      total: resumen.total + 1,
      vistos: resumen.vistos + (turno.visto ? 1 : 0),
      confirmados: resumen.confirmados + (turno.confirmado ? 1 : 0),
    }),
    { total: 0, vistos: 0, confirmados: 0 }
  );

  const reunionesHistoricas = Object.values(

    historial.reduce((grupos, registro) => {

      const id = String(registro.servicio_id || `${registro.fecha_servicio}-${registro.titulo_servicio || ""}`);

      if (!grupos[id]) {

        grupos[id] = {

          id,

          fecha: registro.fecha_servicio,

          hora: registro.hora_servicio,

          titulo: registro.tipo_servicio || registro.titulo_servicio || "Servicio",

          servidores: [],

        };

      }

      grupos[id].servidores.push(registro);

      return grupos;

    }, {})

  );

  const reunionHistorica = reunionesHistoricas.find((reunion) => reunion.id === reunionHistoricaSeleccionada);

  const servidoresHistoricosPorArea = reunionHistorica
    ? Object.values(
        reunionHistorica.servidores.reduce((grupos, registro) => {
          const nombreArea = registro.nombre_area || "Sin área asignada";

          if (!grupos[nombreArea]) {
            grupos[nombreArea] = { nombre: nombreArea, servidores: [] };
          }

          grupos[nombreArea].servidores.push(registro);
          return grupos;
        }, {})
      ).sort((a, b) => a.nombre.localeCompare(b.nombre))
    : [];


  const input = "campo";

  const label = "etiqueta";


  return (

    <div className="p-6">

      <div className="flex items-center justify-between mb-6">

        <div>

          <h2 className="titulo-pagina">Servidores y turnos</h2>

          <p className="text-gray-400 text-sm mt-1">{areas.length} áreas · {miembrosArea.length} servidores · {turnos.length} turnos programados</p>

        </div>

        <span className="text-sm text-gray-400">Las áreas se administran en Configuración</span>

      </div>


      <div className="flex flex-wrap gap-2 mb-6">

        {[

          ["servidores", "Áreas y accesos"],

          ["turnos", "Programar turnos"],

          ["programacion", "Turnos por reunión"],

          ["historial", "Histórico"],

        ].map(([id, labelTab]) => (

          <button

            key={id}

            onClick={() => setTab(id)}

            className={`pestana ${tab === id ? "pestana-activa" : ""}`}

          >

            {labelTab}

          </button>

        ))}

      </div>


      {cargando ? (

        <Esqueleto texto="Cargando servidores…" />

      ) : (

        <>

          {tab === "servidores" && (

            <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">

              <div className="panel p-4">

                <h3 className="titulo-panel mb-4">Áreas</h3>

                {areas.map((a) => (

                  <div key={a.id} className={`w-full rounded-xl mb-2 border p-3 transition ${areaSeleccionada === a.id ? "border-dorado bg-oscuro" : "border-gray-700 hover:border-dorado"}`}>

                    <button onClick={() => setAreaSeleccionada(a.id)} className="w-full text-left">

                      <p className="text-white text-sm font-semibold">{a.nombre}</p>

                      <p className="text-gray-400 text-xs">{miembrosArea.filter((ma) => ma.area_id === a.id).length} servidores</p>

                    </button>

                  </div>

                ))}

              </div>


              <div className="panel lg:col-span-2 p-4">

                <h3 className="titulo-panel mb-4">Asignar servidor</h3>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-3 mb-5">

                  <div className="md:col-span-2">

                    <label className={label}>Buscar miembro</label>

                    <input value={busquedaServidor} onChange={(e) => { setBusquedaServidor(e.target.value); setMiembroServidor(""); }} className={input} placeholder="Nombre" />

                    {miembroServidorSeleccionado && (

                      <div className="mt-2 rounded-xl border border-dorado bg-oscuro p-3 text-sm text-white">

                        {miembroServidorSeleccionado.nombres} {miembroServidorSeleccionado.apellidos}

                      </div>

                    )}

                    {!miembroServidorSeleccionado && busquedaServidor.trim() && (

                      <div className="mt-2 max-h-56 overflow-y-auto rounded-xl border border-gray-700">

                        {resultadosServidor.length === 0 ? (

                          <p className="p-3 text-sm text-gray-400">No hay resultados disponibles.</p>

                        ) : resultadosServidor.map((m) => (

                          <button key={m.id} onClick={() => { setMiembroServidor(String(m.id)); setBusquedaServidor(`${m.nombres} ${m.apellidos}`); }} className="w-full p-3 text-left border-b border-gray-700 last:border-b-0 hover:bg-oscuro">

                            <p className="text-white text-sm font-semibold">{m.nombres} {m.apellidos}</p>

                          </button>

                        ))}

                      </div>

                    )}

                  </div>

                  <div>

                    <label className={label}>Rol en el área</label>

                    {/infantil|kids/i.test(areaSeleccionadaInfo?.nombre || "") ? (
                      <Selector value={rolEnArea} onChange={(e) => setRolEnArea(e.target.value)} className={input}>
                        <option value="">Elegir rol...</option>
                        <option value="profesor">Profesor</option>
                        <option value="asistente">Asistente</option>
                      </Selector>
                    ) : (
                      <input value={rolEnArea} onChange={(e) => setRolEnArea(e.target.value)} className={input} placeholder="Ej: Vocalista" />
                    )}

                  </div>

                </div>

                <button onClick={asignarServidor} disabled={!miembroServidor || !areaSeleccionada} className="w-full mb-6 btn-primario">

                  Asignar al área

                </button>


                <div className="flex flex-wrap items-center justify-between gap-3 mb-3">
                  <div>
                    <h3 className="titulo-panel">Servidores del área</h3>
                    {areaSeleccionadaInfo && <span className="text-gray-400 text-sm">{areaSeleccionadaInfo.nombre}</span>}
                  </div>
                  {sinAcceso.length > 0 && (
                    <button onClick={() => darAcceso(sinAcceso)} className="btn-fantasma btn-sm">
                      Dar acceso a {sinAcceso.length === 1 ? "1 servidor" : `los ${sinAcceso.length} sin usuario`}
                    </button>
                  )}
                </div>
                <p className="mb-4 text-xs text-gray-500">
                  Con acceso, cada servidor entra con su correo para ver sus turnos, con quién sirve y el programa de la reunión.
                </p>

                {!areaSeleccionada ? (
                  <p className="text-gray-400 text-sm">Selecciona un área para ver sus servidores vinculados.</p>
                ) : servidoresDelArea.length === 0 ? (
                  <p className="text-gray-400 text-sm">Esta área aún no tiene servidores asignados.</p>
                ) : (
                  <div className="space-y-2">
                    {servidoresDelArea.map((vinculo) => {
                      const miembro = vinculo.miembros || miembros.find((m) => m.id === vinculo.miembro_id);

                      return (
                        <article key={vinculo.id} className="panel-interior flex flex-col gap-3 p-4 sm:flex-row sm:items-center sm:justify-between">
                          <div>
                            <p className="text-white font-semibold">{miembro ? `${miembro.nombres} ${miembro.apellidos}` : "Miembro no encontrado"}</p>
                            <p className="text-gray-400 text-sm mt-1">{vinculo.rol_en_area || "Servidor"}</p>
                          </div>
                          <div className="flex flex-wrap items-center gap-3">
                            <span className={`insignia ${vinculo.activo !== false ? "border border-emerald-500/30 bg-emerald-500/15 text-emerald-300" : "border border-zinc-500/30 bg-zinc-500/15 text-zinc-400"}`}>
                              {vinculo.activo !== false ? "Activo" : "Inactivo"}
                            </span>
                            {usuarioDe(vinculo.miembro_id) ? (
                              <>
                                <span className="text-xs text-gray-400" title="Usuario con el que entra a la aplicación">
                                  {usuarioDe(vinculo.miembro_id).email}
                                </span>
                                <button onClick={() => reenviarAcceso(usuarioDe(vinculo.miembro_id), miembro)} className="text-gray-300 text-sm hover:text-white">Reenviar acceso</button>
                              </>
                            ) : (
                              <button onClick={() => darAcceso([vinculo.miembro_id])} className="text-white text-sm font-semibold hover:underline">Dar acceso</button>
                            )}
                            <button onClick={() => quitarServidor(vinculo.id)} className="text-red-400 text-sm hover:text-red-300">Quitar</button>
                          </div>
                        </article>
                      );
                    })}
                  </div>
                )}

              </div>

            </div>

          )}


          {tab === "turnos" && (
            <PanelTurnos
              servicios={servicios}
              areas={areas}
              miembros={miembros}
              miembrosArea={miembrosArea}
              turnos={turnos}
              servicioInicial={contexto?.servicioId}
              onCambio={cargarDatos}
            />
          )}

          {tab === "programacion" && (
            <section className="space-y-6">
              <div className="panel p-5">
                <div className="flex flex-col gap-4 lg:flex-row lg:items-end lg:justify-between">
                  <div>
                    <h3 className="text-xl font-black uppercase tracking-tight text-white">Programación de servidores</h3>
                    <p className="text-gray-400 text-sm mt-1">Todos los turnos asignados, organizados por servicio y área.</p>
                  </div>
                  <div className="w-full lg:w-96">
                    <label className={label}>Filtrar por servicio</label>
                    <Selector value={filtroProgramacion} onChange={(e) => setFiltroProgramacion(e.target.value)} className={input}>
                      <option value="">Todos los servicios programados</option>
                      {servicios.map((servicio) => <option key={servicio.id} value={servicio.id}>{servicio.fecha ? new Date(`${servicio.fecha}T00:00:00`).toLocaleDateString("es-CO") : "Sin fecha"} · {servicio.tipos_servicio?.nombre || servicio.titulo || "Servicio"}</option>)}
                    </Selector>
                  </div>
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 mt-5">
                  <div className="panel-interior p-4"><p className="text-gray-400 text-xs uppercase">Turnos asignados</p><p className="text-white text-2xl font-bold mt-1">{resumenProgramacion.total}</p></div>
                  <div className="rounded-xl border border-sky-900 bg-sky-950/30 p-4"><p className="text-sky-300 text-xs uppercase">Vistos</p><p className="text-sky-100 text-2xl font-bold mt-1">{resumenProgramacion.vistos} <span className="text-sm font-normal">de {resumenProgramacion.total}</span></p></div>
                  <div className="rounded-xl border border-green-900 bg-green-950/30 p-4"><p className="text-green-300 text-xs uppercase">Confirmados</p><p className="text-green-100 text-2xl font-bold mt-1">{resumenProgramacion.confirmados} <span className="text-sm font-normal">de {resumenProgramacion.total}</span></p></div>
                </div>
              </div>

              {programacionPorServicio.length === 0 ? <div className="panel p-10 text-center text-gray-400">No hay turnos programados para este filtro.</div> : programacionPorServicio.map((servicio) => (
                <article key={servicio.id} className="panel overflow-hidden">
                  <header className="border-b border-gray-700 bg-oscuro/60 p-5 flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between"><div><p className="text-white font-bold text-xs uppercase">{servicio.tipo}</p><h4 className="text-white text-lg font-bold mt-1">{servicio.titulo}</h4></div><p className="text-gray-300 text-sm">{servicio.fecha ? new Date(`${servicio.fecha}T00:00:00`).toLocaleDateString("es-CO", { weekday: "long", day: "numeric", month: "long", year: "numeric" }) : "Fecha por definir"}{servicio.hora ? ` · ${servicio.hora.slice(0, 5)}` : ""}</p></header>
                  <div className="p-5 grid grid-cols-1 xl:grid-cols-2 gap-5">{servicio.areas.map((area) => <section key={area.id} className="rounded-xl border border-gray-700 bg-oscuro/50 overflow-hidden"><div className="px-4 py-3 border-b border-gray-700 flex items-center justify-between"><h5 className="text-dorado font-bold">{area.nombre}</h5><span className="text-gray-400 text-xs">{area.turnos.length} servidor(es)</span></div><div className="divide-y divide-gray-700">{area.turnos.map((turno) => <div key={turno.id} className="p-4 flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between"><div><p className="text-white font-semibold">{turno.miembros?.nombres || "Servidor"} {turno.miembros?.apellidos || ""}</p><p className="text-gray-400 text-sm mt-1">{turno.rol_en_turno || "Servidor"}</p>{turno.notas && <p className="text-gray-500 text-xs mt-2">{turno.notas}</p>}{turno.rechazado && <p className="text-red-300 text-xs mt-2">Motivo del rechazo: {turno.motivo_rechazo || "No indicó un motivo"}</p>}</div><div className="flex flex-wrap gap-2 sm:justify-end"><span className={`rounded-full px-2.5 py-1 text-xs font-semibold ${turno.visto ? "bg-sky-900/60 text-sky-300" : "border border-zinc-500/30 bg-zinc-500/15 text-zinc-400"}`}>{turno.visto ? "Visto" : "Sin ver"}</span><span className={`rounded-full px-2.5 py-1 text-xs font-semibold ${estadoTurno(turno).clase}`}>{estadoTurno(turno).texto}</span></div></div>)}</div></section>)}</div>
                </article>
              ))}
            </section>
          )}

          {tab === "historial" && (

            <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">

              <section className="panel p-4">

                <h3 className="titulo-panel">Últimas reuniones</h3>

                <p className="text-gray-400 text-xs mt-1">Selecciona una reunión para ver los servidores.</p>

                {reunionesHistoricas.length === 0 ? (

                  <p className="text-gray-500 text-sm mt-4">Aún no hay reuniones archivadas.</p>

                ) : (

                  <div className="mt-4 space-y-2">

                    {reunionesHistoricas.map((reunion) => (

                      <button

                        key={reunion.id}

                        onClick={() => setReunionHistoricaSeleccionada(reunion.id)}

                        className={`w-full text-left rounded-xl border p-3 transition ${reunionHistoricaSeleccionada === reunion.id ? "border-dorado bg-dorado/10" : "border-gray-700 bg-oscuro hover:border-dorado"}`}

                      >

                        <p className="text-white text-sm font-semibold">{reunion.titulo}</p>

                        <p className="text-gray-400 text-xs mt-1">

                          {reunion.fecha ? new Date(reunion.fecha + "T00:00:00").toLocaleDateString("es-CO") : "Fecha no registrada"}

                          {reunion.hora ? ` · ${reunion.hora.slice(0, 5)}` : ""}

                          {` · ${reunion.servidores.length} servidor(es)`}

                        </p>

                      </button>

                    ))}

                  </div>

                )}

              </section>


              <section className="panel lg:col-span-2 p-5">

                {!reunionHistorica ? (

                  <p className="text-gray-400 text-center py-12">Selecciona una reunión de la lista.</p>

                ) : (

                  <>

                    <h3 className="text-xl font-black uppercase tracking-tight text-white">{reunionHistorica.titulo}</h3>

                    <p className="text-gray-400 text-sm mt-1">

                      {reunionHistorica.fecha ? new Date(reunionHistorica.fecha + "T00:00:00").toLocaleDateString("es-CO") : "Fecha no registrada"}

                    </p>

                    <div className="mt-5 space-y-5">

                      {servidoresHistoricosPorArea.map((grupo) => (

                        <section key={grupo.nombre} className="rounded-xl border border-gray-700 bg-oscuro/40 p-4">

                          <h4 className="titulo-panel mb-3">{grupo.nombre}</h4>

                          <div className="space-y-3">

                            {grupo.servidores.map((registro) => (

                              <article key={registro.id} className="panel-interior p-4 flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">

                                <div>

                                  <p className="text-white font-semibold">{registro.nombre_servidor || "Servidor"}</p>

                                  <p className="text-gray-400 text-sm mt-1">{registro.rol_en_turno || "Servidor"}</p>

                                </div>

                                <span className={`insignia ${registro.confirmado ? "border border-emerald-500/30 bg-emerald-500/15 text-emerald-300" : "border border-amber-500/30 bg-amber-500/15 text-amber-300"}`}>

                                  {registro.confirmado ? "Confirmó asistencia" : "No confirmó"}

                                </span>

                              </article>

                            ))}

                          </div>

                        </section>

                      ))}

                    </div>

                  </>

                )}

              </section>

            </div>

          )}


        </>

      )}


    </div>

  );

}


export default Servidores;


